import { useLocalSearchParams } from "expo-router";
import { ReportsListItem } from "@src/components/web/ReportsListItem.web";
import { ReportsSection } from "@src/components/web/ReportsSection.web";
import { PATRIOT_TOOLS, patriotToolsHref } from "../routes";
import { PatriotToolsPage } from "../components/PatriotToolsPage";

export function PatriotToolsIndexScreen() {
  const { tenantId } = useLocalSearchParams<{ tenantId: string }>();

  return (
    <PatriotToolsPage subtitle="Internal views over the Patriot monitoring replica. Visible to support users only.">
      <ReportsSection title="Query">
        {PATRIOT_TOOLS.map((tool) => (
          <ReportsListItem
            key={tool.subpath}
            title={tool.title}
            subtitle={tool.description}
            href={patriotToolsHref(tenantId, tool.subpath)}
          />
        ))}
      </ReportsSection>
    </PatriotToolsPage>
  );
}
